module.exports = __webpack_public_path__ + "static/payment50-5784c4a54da5cd82689dd21ea7afa046.jpg";